import { Component, OnInit, ViewChild } from "@angular/core";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { DeleteUsers } from "../../../../core/models/users/users/deleteUsers";
import { ValidateLogin } from "../../../../core/models/common/validateLogin";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { SharedService } from "../../../../core/services/shared.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { CommonModule } from "@angular/common";
import { Table, TableFilterEvent, TableModule } from "primeng/table";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "primeng/api";
import { SliderModule } from "primeng/slider";
import { ContextMenuModule } from "primeng/contextmenu";
import { ProgressBarModule } from "primeng/progressbar";
import { SelectModule } from "primeng/select";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ProfileComponent } from "../../../profile/profile.component";
import { ImportUserComponent } from "../import-user/import-user.component";
import { CardModule } from "primeng/card";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { DrawerModule } from "primeng/drawer";
import { ToggleButtonModule } from "primeng/togglebutton";
import { HeaderService } from "../../../../core/services/header.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UsersListingService } from "../../../../core/services/users-listing.service";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
@UntilDestroy()
@Component({
  selector: "jni-users-listing",
  templateUrl: "./users-listing.component.html",
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    SliderModule,
    DialogModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    ReactiveFormsModule,
    FormsModule,
    SelectModule,
    ConfirmDialogModule,
    SharedModule,
    ModalStackerComponent,
    ConfirmDialogModule,
    ProfileComponent,
    ImportUserComponent,
    CardModule,
    ToggleSwitchModule,
    DrawerModule,
    ToggleButtonModule,
    SpinnerComponent,
    ConfirmDialogComponent,
  ],
  styleUrls: ["./users-listing.component.scss"],
})
export class UsersListingComponent implements OnInit {
  @ViewChild("dt") table!: Table;
  userListings: UsersList[] = [];
  userIds: number[] = [];
  UserSupportMapIds?: DeleteUsers;
  selectedUsers: UsersList[] = [];
  isImportDisabled = false;
  popupmessage = "";
  username = "";
  dialogStatus = false;
  exportExcelUserListing: UsersList[] = [];
  filteredUserListings: UsersList[] = [];
  showSmallLoader = false;
  importUserRights = false;
  userRoleId = 0;
  selectedUserId = 0;
  userDisplayModal = false;
  toggleImportDrawer = false;

  constructor(
    private _usersListingService: UsersListingService,
    private _toastr: JniToastrService,
    // private _loaderService: LoaderService,
    private _loginService: UserManagementService,
    private _sharedService: SharedService,
    private _headerService: HeaderService
  ) {}

  ngOnInit() {
    this.getUsersListingData();
    this.getLoginUser();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
    this._headerService.headerTagsVisibility(true);
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  getLoginUser() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res.data) {
          this.userRoleId = res.data.userRoleId;
          if (this.userRoleId === UserRole.Admin) {
            this.importUserRights = true;
          } else {
            this.importUserRights = false;
          }
        }
      });
  }

  onActiveSwitch(value: UsersList, event: Event) {
    const target = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    this._usersListingService
      .UpdateUserProfileActive({
        id: value.id,
        isProfileActive: target.checked,
      })
      .subscribe(() => {
        this.showSmallLoader = false;
      });
  }

  fetchUsers(event: boolean) {
    if (event) {
      this.getUsersListingData();
    }
  }

  getUsersListingData() {
    // this._loaderService.setLoaderState(true);
    this.showSmallLoader = true;
    this._usersListingService
      .getUsers()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<UsersList[]>) => {
          if (res.status.toLowerCase() === "success") {
            this.isImportDisabled = false;
          } else {
            this.isImportDisabled = true;
          }

          this.userListings = res.data;
          this.showSmallLoader = false;
          // this._loaderService.setLoaderState(false);
        },
        error: () => {
          this.showSmallLoader = false;
          // this._loaderService.setLoaderState(false);
        },
        complete: () => {
          this.showSmallLoader = false;
        },
      });
  }

  exportExcelForFilterData(excelUserList: UsersList[]) {
    const object = excelUserList.map(datum => {
      return {
        Name: datum.name,
        ADLogin: datum.loginEmail,
        Type:
          datum?.userRoleName?.toLowerCase() === "power use"
            ? "Power User"
            : datum.userRoleName,
        PersonnelNumber: datum.personnelNumber,
        Active: datum.isProfileActive ? "Yes" : "No",
        Ledger: datum.isLedgerActive ? "Yes" : "No",
        Office: datum.locationName,
        Title: datum.title,
      };
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "UserList");
    });
  }

  onFilter(event: TableFilterEvent) {
    this.filteredUserListings = event.filteredValue;
  }

  exportExcel() {
    this.showSmallLoader = true;
    if (this.selectedUsers.length > 0) {
      this.exportExcelForFilterData(this.selectedUsers);
      this.showSmallLoader = false;
    } else if (this.filteredUserListings.length > 0) {
      this.exportExcelForFilterData(this.filteredUserListings);
      this.showSmallLoader = false;
    } else {
      this.exportExcelForFilterData(this.userListings);
      this.showSmallLoader = false;
    }
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }
  getCurrentUser(event: UsersList) {
    // this._router.navigate(['/profile/' + event.id]);
    this.selectedUserId = event.id;
    this.userDisplayModal = true;
  }

  closeUserModal() {
    this.userDisplayModal = false;
  }

  deleteDialog() {
    if (this.selectedUsers.length > 0) {
      this.username =
        this.selectedUsers.length > 1
          ? this.selectedUsers.length.toLocaleString()
          : this.selectedUsers[0].name;
      this.popupmessage = `Are you sure you want to delete ${this.username} user from Users`;
      this.dialogStatus = true;
    }
  }

  confirmDialogStatusData(status: boolean) {
    this.dialogStatus = false;
    if (status) {
      this.deleteUser();
    }
  }

  deleteUser() {
    this.userIds = [];
    for (const user of this.selectedUsers) {
      this.userIds.push(user.id);
    }
    this.UserSupportMapIds = {
      UserIds: this.userIds,
    };
    this.showSmallLoader = true;
    this._usersListingService
      .deleteUsers(this.UserSupportMapIds)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.selectedUsers.length = 0;
          this._toastr.success("Success", "User deleted Successfully");
          this.getUsersListingData();
          this.showSmallLoader = false;
        },
        error: () => {
          this._toastr.success("Error", "Error deleting user");
          this.showSmallLoader = false;
        },
      });
  }

  clickDisabled(event: MouseEvent) {
    event.preventDefault();
  }
}
